import Swal from 'sweetalert2';
import strings from '../Globalization';
import consts from '../consts';
import Model from '../models/model';
import connectionService from '../services/Connection';
import util, { hasEndoProduct } from '../util';
import { dataStore } from '../Store';

const { EquipmentFamilyType } = consts;
const { ConnectivityType } = consts;
const { ModelType } = consts;
const { EquipmentFamilyID } = consts;
const { AssertSteam, CelerityHP, CeleritySteam, EndoDry, ADV, AMSCO3052, AMSCO600US, VPROMAX2, VPROS2, AMSCO5052, AMSCO7053L, AMSCO7052HP, AMSCO7053HP, AMSCO1215, System1Endo2, PTX, Enspire300SeriesAER
	, CenturyMedium, CenturySmall, AMSCO400, Evolution, VPRO1, VPROMAX, Synergy, VisionMultiChamber, VisionSingleChamber, Vision1300series, Reliance1227, RelianceCabinet, UniversalIncubator, WasherCart } = ModelType;
const { EndoCabinet, Kodiak, AMSCO600EU, Directory, None, PlugAndPlay, CATSync, Advantage } = ConnectivityType;
const validateConnectivityGroup = [Kodiak, AMSCO600EU, Directory, None, PlugAndPlay, CATSync];
const isEndoValidation = [EquipmentFamilyID.Advantage, consts.EquipmentFamilyID.EndoCabinet, consts.EquipmentFamilyID.RelianceCabinet];
const HuluEquipmentFamily = [EquipmentFamilyType.ADVANTAGE, EquipmentFamilyType.RAPIDAER, EquipmentFamilyType.LIQUIDCHEMICALENSPIRE3000, EquipmentFamilyType.AERXML,EquipmentFamilyType.AERDSD ];
const NonHuluEquipmentFamily = [EquipmentFamilyType.ADVANTAGE, EquipmentFamilyType.RAPIDAER];
const UseAlcoholEquipmentFamily = [EquipmentFamilyType.ADVANTAGE, EquipmentFamilyType.RAPIDAER];
const minHuluMachineModelId = 10;
const setEmptyKeys = ['DetergentId', 'DetergentName', 'ConfigUsageIdStd', 'ConfigUsageStd', 'ConfigUsageIdAlc', 'ConfigUsageAlc'];


const isLimitedUser = () =>
	Array.isArray(util.localData?.loginData?.roles)
		? util.localData?.loginData?.roles.includes('Supervisor')
		: util.localData?.loginData?.roles === 'Supervisor';


const validateHulu = ({ formik = {}}) => {
	const { EquipmentFamilyId } = formik?.values || {};
	return HuluEquipmentFamily.includes(EquipmentFamilyId) && util.nonSterisHide(formik);
}

const validateNonHulu = ({ formik ={}}) => {
	const { EquipmentFamilyId } = formik?.values || {};
	return NonHuluEquipmentFamily.includes(EquipmentFamilyId) && util.nonSterisHide(formik);
}

const validateAlcohol = ({ formik = {}}) => {
	const { EquipmentFamilyId } = formik?.values || {};
	return UseAlcoholEquipmentFamily.includes(EquipmentFamilyId);
}

const validateAREXML = ({ formik = {}}) => {
	const { EquipmentFamilyId } = formik?.values || {};
	return EquipmentFamilyType.AERXML === EquipmentFamilyId;
};

const validateHuluWithDSD = ({ formik = {}}) => {
	const { EquipmentFamilyId } = formik?.values || {};
	return EquipmentFamilyType.AERDSD === EquipmentFamilyId;
}

const advModelReadOnlyConditions = [
	{
		field: 'ConnectivityType',
		op: 'in',
		value: () => [Advantage]
	}
];

const disableField = () => {
	return false;
}
/**
 * Populates detergent-related values in the active record and formik form state.
 *
 * @param {Object} params - The function parameters.
 * @param {number|string} params.detergentValue - The LookupId of the selected detergent.
 * @param {Object} params.activeRecord - The active record object containing combos and the record to update.
 * @param {Object} params.activeRecord.combos - The combos object containing detergent list.
 * @param {Array} params.activeRecord.combos.HULUDetergent - Array of detergent objects with LookupId and DisplayValue.
 * @param {Object} params.activeRecord.record - The record object where detergent values are set.
 * @param {Object} params.formik - The Formik instance used to set form field values.
 */
const populateDetergentValue = ({ detergentValue, activeRecord, formik }) => {
	const { HULUDetergent } = activeRecord.combos;
	const detergentName = HULUDetergent.filter(detergent => detergent.LookupId === detergentValue) || [];
	activeRecord.record.DetergentId = detergentValue ?? '';
	activeRecord.record.DetergentName = detergentName.length !== 0 ? detergentName[0]?.DisplayValue : '';
	formik.setFieldValue('DetergentId', detergentValue);
	formik.setFieldValue('DetergentName', detergentName.length !== 0 ? detergentName[0]?.DisplayValue : '');
}
/**
 * Constructs a FormData object with parameters required to fetch cycle types.
 *
 * @param {Object} params - The parameters object.
 * @param {Object} params.activeRecord - The active record containing the current record data.
 * @param {Object} params.activeRecord.record - The record object with relevant IDs.
 * @param {number|string} params.chemistryId - The ID for the chemistry selection.
 * @param {boolean|string} params.doubleWash - Flag indicating if double wash is enabled.
 * @returns {FormData} The populated FormData instance ready for submission.
 */
const getFormData = ({ activeRecord, chemistryId, doubleWash }) => {
	const formData = new FormData();
	formData.append('action', 'otherAction');
	formData.append('otherAction', 'GetCycleTypes');
	formData.append('MachineModelId', activeRecord.record.HuluMachineModelID);
	formData.append('RegionId', activeRecord.record.HuluRegionId);
	formData.append('ChemistryId', chemistryId);
	formData.append('DetergentId', activeRecord.record.DetergentId);
	formData.append('DoubleWash', doubleWash);
	return formData;
}
/**
 * Fetches Hulu machine configuration cycle types and updates formik fields and activeRecord accordingly.
 *
 * @param {Object} params - Parameters object.
 * @param {import('formik').FormikHelpers} params.formik - Formik instance to update form fields.
 * @param {Object} params.activeRecord - The active record object containing current record and combos.
 * @param {Object} params.activeRecord.record - The record object to update with cycle configuration IDs.
 * @param {FormData} params.formData - FormData object with required parameters for the fetch request.
 *
 * @returns {Promise<void>} Resolves when data is fetched and state is updated; shows alerts on error or no data.
 */
const fetchData = async ({ formik, activeRecord, formData }) => {
	const response = await fetch(connectionService.HuluMachineConfig, { method: 'POST', body: formData });
	const result = await response.json();
	if (result.err) {
		Swal.fire({
			title: strings.Error,
			text: strings[result.err] || result.err,
			icon: "error",
			confirmButtonText: strings.Ok,
			allowOutsideClick: false
		});
		return;
	}
	const data = result.data || [];
	if (data.length === 2) {
		const [standardCycle] = data.filter(f => !f.UseAlcohol);
		const [alcoholCycle] = data.filter(f => f.UseAlcohol);

		if (standardCycle) {
			formik.setFieldValue('ConfigUsageIdStd', standardCycle.ConfigUsageId);
			formik.setFieldValue('ConfigUsageStd', standardCycle.CycleType);
			activeRecord.record.ConfigUsageIdStd = standardCycle.ConfigUsageId;
		}
		if (alcoholCycle) {
			formik.setFieldValue('ConfigUsageIdAlc', alcoholCycle.ConfigUsageId);
			formik.setFieldValue('ConfigUsageAlc', alcoholCycle.CycleType);
			activeRecord.record.ConfigUsageIdAlc = alcoholCycle.ConfigUsageId;
		}
	} else if (data.length === 1 && activeRecord.record.HuluMachineModelID >= minHuluMachineModelId) { //Other Scenario - There is no Use Alcohol flag 
		const [standardCycle] = data;
		formik.setFieldValue('ConfigUsageIdStd', standardCycle.ConfigUsageId);
		formik.setFieldValue('ConfigUsageStd', standardCycle.CycleType);
		activeRecord.record.ConfigUsageIdStd = standardCycle.ConfigUsageId;
	} else {
		formik.setFieldValue('ConfigUsageIdStd', '');
		formik.setFieldValue('ConfigUsageStd', '');
		formik.setFieldValue('ConfigUsageIdAlc', '');
		formik.setFieldValue('ConfigUsageAlc', '');
		activeRecord.record.ConfigUsageIdStd = '';
		activeRecord.record.ConfigUsageIdAlc = '';
		Swal.fire({
			title: strings.Hulucycletypes,
			text: strings.Cycletypesnotfound,
			icon: "error",
			confirmButtonText: strings.Ok,
			allowOutsideClick: false
		});
	}
}
/**
 * Populates Hulu cycles by updating detergent value, preparing form data, and fetching cycle configurations.
 *
 * @param {Object} params - Parameters object.
 * @param {import('formik').FormikHelpers} params.formik - Formik instance to update form fields.
 * @param {Object} params.activeRecord - The active record object containing current record and combos.
 * @param {any} params.value - The detergent LookupId value to populate.
 *
 * @returns {Promise<void>} Resolves after detergent value is set and cycle data is fetched and applied.
 */
const populateHuluCycles = async ({ formik, activeRecord, value }) => {
	const { ChemistryId } = activeRecord.record;
	populateDetergentValue({ activeRecord, detergentValue: value, formik });
	const formData = getFormData({ activeRecord, chemistryId: ChemistryId, doubleWash: activeRecord.record.DoubleWash });
	await fetchData({ formik, activeRecord, formData });
}
/**
 * Updates the DoubleWash flag in activeRecord, populates detergent values, and fetches Hulu cycle configurations accordingly.
 *
 * @param {Object} params - Parameters object.
 * @param {import('formik').FormikHelpers} params.formik - Formik instance to update form fields.
 * @param {Object} params.activeRecord - The active record object containing current record and combos.
 * @param {any} params.value - The new value for the DoubleWash flag.
 *
 * @returns {Promise<void>} Resolves after updating DoubleWash and fetching updated cycle data.
 */
const populateHuluCycleByDubelWash = async ({ formik, activeRecord, value }) => {
	const { ChemistryId } = activeRecord.record;
	activeRecord.record.DoubleWash = value;
	populateDetergentValue({ activeRecord, detergentValue: activeRecord.record.DetergentId, formik });
	const formData = getFormData({ activeRecord, chemistryId: ChemistryId || '', doubleWash: activeRecord.record.DoubleWash });
	await fetchData({ formik, activeRecord, formData });
}
export const valueRenderr = (colDef, value, comboName) => {
	const data = colDef.getCombos()
	return data[comboName]?.find((({ LookupId }) => LookupId === value))?.DisplayValue
}
const disabeldField = () => {
	const { tags } = dataStore.getState().auth || {};
	return ['steris specialist'].includes(tags?.RoleName?.toLowerCase());
};

const model = new Model({
	name: 'Model',
	defaultSort: 'ModelName',
	gridTitle: 'EquipmentModel',
	initialValues: {
		IsActive: true
	},
	formTitleField: 'ModelName',
	disableAdd: true,
	readOnly: isLimitedUser,
	disableDelete: true,
	showGridRefreshBtn: true,
	customizeSaveData: (toSave, { activeRecord, searchParams }) => {
		if (!toSave.ConnectivityType) {
			toSave.ConnectivityType = 0;
		}
		if (!toSave.CATExportEquipment || validateConnectivityGroup.includes(toSave.ConnectivityType)) {
			toSave.CATExportEquipment = 0;
		}
		if (isEndoValidation.includes(toSave.EquipmentFamilyId)) {
			toSave.Endo = true;
		}

		toSave.ChemistryName = activeRecord.record.ChemistryName;
		toSave.DetergentName = activeRecord.record.DetergentName;
		toSave.ConfigUsageIdStd = activeRecord.record.ConfigUsageIdStd;
		toSave.ConfigUsageIdAlc = activeRecord.record.ConfigUsageIdAlc;
		toSave.DetergentId = activeRecord.record.DetergentId;
		toSave.HuluMachineFamilyId= activeRecord.record.HuluMachineFamilyId;
		toSave.HuluMachineFamilyName=activeRecord.record.HuluMachineFamilyName;
		toSave.HuluMachineFamilyId=activeRecord.record.HuluMachineFamilyId;
		toSave.HuluMachineModelID=activeRecord.record.HuluMachineModelID;
		toSave.HuluMachineModelName=activeRecord.record.HuluMachineModelName
		toSave.HuluRegionId=activeRecord.record.HuluRegionId;
		const returnTo = decodeURIComponent(searchParams.get('returnTo'));
		const returnToString = returnTo.substring(returnTo.indexOf('?'));
		const returnToSP = new URLSearchParams(returnToString);
		toSave.EquipmentId = returnToSP.get('id');
		return toSave
	},
	comboTypes: [
		{ type: 'EquipmentFamily', loaded: true },
		{ type: 'ConnectivityType', loaded: true },
		{ type: 'CycleTime', loaded: true },
		{ type: 'DataExportEquipmentFamily', loaded: true },
		{ type: 'HULUChemistry', loaded: true },
		{ type: 'HULUDetergent', loaded: true },
		{ type: 'ModelDeviceType', loaded: true },
		{ type: 'ModelDataTypes', loaded: true }
	],
	onFormLoad: ({ formik, activeRecord }) => {
		activeRecord = activeRecord ? activeRecord : {};
		const { record = {} } = activeRecord;
		const modelId = record.Connectivity ? '' : record?.ModelId;
		switch (modelId) {
			case AMSCO3052:
			case AMSCO600US:
			case VPROMAX2:
			case VPROS2:
			case AMSCO5052:
			case AMSCO7053L:
			case AMSCO7052HP:
			case AMSCO7053HP:
			case AMSCO1215:
			case System1Endo2:
			case PTX:
			case Enspire300SeriesAER:
				formik.setFieldValue('ConnectivityType', Kodiak);
				formik.setFieldValue('Connectivity', 'Kodiak');
				break;
			case ModelType.AMSCO600EU:
				formik.setFieldValue('ConnectivityType', AMSCO600EU);
				formik.setFieldValue('Connectivity', 'AMSCO600EU');
				break;
			case CenturyMedium:
			case CenturySmall:
			case AMSCO400:
			case Evolution:
			case VPRO1:
			case VPROMAX:
			case Synergy:
			case VisionMultiChamber:
			case VisionSingleChamber:
			case Vision1300series:
			case Reliance1227:
			case RelianceCabinet:
			case UniversalIncubator:
			case WasherCart:
				formik.setFieldValue('ConnectivityType', CATSync);
				formik.setFieldValue('Connectivity', 'CATSync');
				break;
			case ADV:
				formik.setFieldValue('ConnectivityType', Advantage);
				formik.setFieldValue('Connectivity', 'Advantage');
				break;
			case EndoDry:
				formik.setFieldValue('ConnectivityType', EndoCabinet);
				formik.setFieldValue('Connectivity', 'EndoCabinet');
				break;
			case CeleritySteam:
			case CelerityHP:
			case AssertSteam:
				formik.setFieldValue('ConnectivityType', PlugAndPlay);
				formik.setFieldValue('Connectivity', 'PlugAndPlay');
				break;
			default:
				break;
		}
	},
	formGroups: [
		{
			fields: [
				'EquipmentFamilyId',
				'ModelName',
				'ConnectivityType',
				'CycleType',
				'WellCount',
				'CycleTime',
				'ChemistryId',
				'DetergentId',
				'DetergentName',
				'DoubleWash',
				'ConfigUsageIdStd',
				'ConfigUsageStd',
				'ConfigUsageIdAlc',
				'ConfigUsageAlc',
				'CATExportEquipment',
				'DeviceType',
				'DataType',
				'MaxHangTime',
				'AllowMultiScopes',
				'UseAlcohol',
				'IsActive',
				'UserRFID',
				'ScopeRFID',
				'SCMModel'
			],
			columnSize: 12
		}
	],
	columns: [
		{
			header: 'UniqueId',
			field: 'ModelId',
			width: 120,
			hide: true,
			isNotformfield: true,
			type: 'string'
		},
		{
			header: 'ModalName',
			field: 'ModelName',
			width: 220,
			required: true,
			ignoreLookupOnGridFilter: true,
			type: 'string',
			minLength: 1,
			maxLength: 50,
			disabled: true
		},
		{
			header: 'EquipmentFamily',
			field: 'EquipmentFamily',
			formField: 'EquipmentFamilyId',
			resets: ['ConnectivityType', 'CATExportEquipment'],
			width: 200,
			required: true,
			type: 'string',
			lookup: 'EquipmentFamily',
			ignoreLookupOnGridFilter: true,
			disabled: disabeldField
		},
		{
			header: 'ConnectivityType',
			field: 'Connectivity',
			formField: 'ConnectivityType',
			width: 160,
			type: 'string',
			resets: ['CATExportEquipment'],
			lookup: 'ConnectivityType',
			ignoreLookupOnGridFilter: true,
			readOnly: [
				{
					field: 'EquipmentFamilyId',
					op: 'in',
					value: () => [consts.EquipmentFamilyType.NONSTERISHP, consts.EquipmentFamilyType.NONSTERISSTEAM]
				}
			],
			required: [
				{
					field: 'EquipmentFamilyId',
					op: 'nin',
					value: () => [consts.EquipmentFamilyType.NONSTERISHP, consts.EquipmentFamilyType.NONSTERISSTEAM]
				}
			],
			disabled: disabeldField,
			inputWhen: ({ formik }) => util.nonSterisHide(formik),
		},
		{
			field: 'ChemistryName',
			formField: 'ChemistryId',
			header: 'Disinfectant(Chemistry)',
			width: 150,
			lookup: 'HULUChemistry',
			type: 'string',
			ignoreLookupOnGridFilter: true,
			inputWhen: ({ formik }) => validateHulu({ formik }) && hasEndoProduct(),
			excludeOnGrid: () => !hasEndoProduct(),
			onChange: ({ value, formik, activeRecord }) => {
				const { HULUChemistry } = activeRecord.combos;
				const ChemistryName = HULUChemistry.filter((chemistry) => chemistry.LookupId === value) || [];
				activeRecord.record.ChemistryId = value;
				activeRecord.record.ChemistryName = ChemistryName.length !== 0 ? ChemistryName[0]?.DisplayValue : '';
				formik.setFieldValue('ChemistryId', value);
				formik.setFieldValue('ChemistryName', ChemistryName.length !== 0 && value ? ChemistryName[0]?.DisplayValue : '');
				setEmptyKeys.forEach((key) => {
					formik.setFieldValue(key, '');
				})
				activeRecord.record.ConfigUsageIdStd = '';
				activeRecord.record.ConfigUsageIdAlc = '';
			},
			required: [{ field: "EquipmentFamilyId", op: 'eq', value: EquipmentFamilyType.ADVANTAGE }, { field: 'ConnectivityType', op: 'ne', value: Advantage }, hasEndoProduct ],
			readOnly: advModelReadOnlyConditions
		},
		{
			field: 'DetergentName',
			header: 'Detergent',
			lookup: 'HULUDetergent',
			type: 'string',
			ignoreLookupOnGridFilter: true,
			inputWhen: ({ formik }) => validateHulu({ formik }) && hasEndoProduct(),
			excludeOnGrid: () => !hasEndoProduct(),
			onChange: populateHuluCycles,
			eager: true,
			maxLength: 50,
			width: 160,
			required: [{ field: "EquipmentFamilyId", op: 'eq', value: EquipmentFamilyType.ADVANTAGE }, { field: 'ConnectivityType', op: 'ne', value: Advantage }, hasEndoProduct],
			readOnly: advModelReadOnlyConditions
		},
		{
			field: 'DoubleWash',
			header: 'DoubleWash',
			type: 'bool',
			maxLength: 50,
			inputWhen: ({ formik }) => !validateHuluWithDSD({ formik })&& validateHulu({ formik }) && hasEndoProduct() && !validateAREXML({ formik }) ,
			excludeOnGrid: () => !hasEndoProduct(),
			width: 150,
			readOnly: advModelReadOnlyConditions,
			onChange: populateHuluCycleByDubelWash,
			eager: true
		},
		{
			field: 'ConfigUsageStd',
			formField: 'ConfigUsageStd',
			header: "Configusagestandard",
			readOnly: true,
			maxLength: 100,
			inputWhen: ({ formik }) => validateHulu({ formik }) && hasEndoProduct(),
			excludeOnGrid: () => !hasEndoProduct(),
			width: 180,
		},
		{
			field: 'ConfigUsageAlc',
			formField: 'ConfigUsageAlc',
			header: 'Configusagealcohol',
			readOnly: true,
			maxLength: 100,
			inputWhen: ({ formik }) =>!validateHuluWithDSD({ formik }) && validateHulu({ formik }) && hasEndoProduct(),
			excludeOnGrid: () => !hasEndoProduct(),
			width: 180
		},
		{
			field: 'AllowMultiScopes',
			header: 'Dualscope',
			type: 'bool',
			maxLength: 50,
			inputWhen: ({ formik }) => !validateHuluWithDSD({ formik }) && validateHulu({ formik }) && hasEndoProduct() && !validateAREXML({ formik }),
			excludeOnGrid: () => !hasEndoProduct(),
			width: 150,
			readOnly: advModelReadOnlyConditions
		},
		{
			field: 'UseAlcohol',
			header: 'UseAlcohol',
			type: 'bool',
			excludeOnGrid: () => !hasEndoProduct(),
			maxLength: 50,
			inputWhen: ({ formik }) => !validateHuluWithDSD({ formik }) && (validateNonHulu({ formik }) && validateAlcohol({ formik }) && hasEndoProduct()) || validateAREXML({ formik }),
			width: 130,
			readOnly: advModelReadOnlyConditions
		},
		{
			field: 'WellCount',
			type: 'number',
			width: 150,
			align: 'left',
			headerAlign: 'left',
			hide: true,
			minValue: 0,
			maxLength: 5,
			defalultValue: 0,
			inputWhen: [
				{
					field: 'EquipmentFamilyId',
					op: ({ value }) =>
						[
							consts.EquipmentFamilyType.IncubatorSteam,
							consts.EquipmentFamilyType.IncubatorVHP,
							consts.EquipmentFamilyType.INCUBATORUNIVERSAL
						].includes(value)
				}
			],
			disabled: disabeldField
		},
		{
			header: 'CycleLength',
			field: 'Time',
			formField: 'CycleTime',
			lookup: 'CycleTime',
			hide: true,
			ignoreLookupOnGridFilter: true,
			width: 120,
			inputWhen: [
				{
					field: 'EquipmentFamilyId',
					op: ({ value }) =>
						[
							consts.EquipmentFamilyType.IncubatorSteam,
							consts.EquipmentFamilyType.IncubatorVHP,
							consts.EquipmentFamilyType.INCUBATORUNIVERSAL
						].includes(value),
				}
			],
			disabled: disabeldField
		},
		{
			header: 'CATExportEquipment',
			field: 'CATExportEquipment',
			width: 200,
			excludeOnGrid: true,
			lookup: 'DataExportEquipmentFamily',
			disabled: disabeldField,
			readOnly: [
				{
					field: 'EquipmentFamilyId',
					op: 'in',
					value: [consts.EquipmentFamilyType.NONSTERISSTEAM, consts.EquipmentFamilyType.NONSTERISHP]
				}
			],
			inputWhen: [
				{
					field: 'ConnectivityType',
					op: 'in',
					value: () => [
						consts.ConnectivityType.Advantage,
						consts.ConnectivityType.EndoCabinet,
						consts.ConnectivityType.Proconnect,
						consts.ConnectivityType.CSVConvert
					]
				}
			],
			required: [
				{
					field: 'ConnectivityType',
					op: 'in',
					value: () => [
						consts.ConnectivityType.Advantage,
						consts.ConnectivityType.EndoCabinet,
						consts.ConnectivityType.Proconnect,
						consts.ConnectivityType.CSVConvert
					]
				}
			]
		},
		{
			header: 'Active',
			field: 'IsActive',
			type: 'boolean',
			width: 130,
			disabled: disabeldField
		},
		{
			header: 'DeviceType',
			field: 'DeviceType',
			hidden: true,
			lookup: 'ModelDeviceType',
			required: [
				{
					field: 'EquipmentFamilyId',
					op: 'nin',
					value: () => [consts.EquipmentFamilyType.NONSTERISHP, consts.EquipmentFamilyType.NONSTERISSTEAM]
				}
			],
			width: 130,
			renderCell: ({ colDef, value }) => valueRenderr(colDef, value, 'ModelDeviceType'),
			disabled: disabeldField,
			excludeOnGrid: () => !hasEndoProduct(),
			inputWhen: ({ formik }) => util.nonSterisHide(formik) && hasEndoProduct(),
			readOnly: advModelReadOnlyConditions
		},
		{
			header: 'DataType',
			field: 'DataType',
			hidden: true,
			lookup: 'ModelDataTypes',
			required: [
				{
					field: 'EquipmentFamilyId',
					op: 'nin',
					value: () => [consts.EquipmentFamilyType.NONSTERISHP, consts.EquipmentFamilyType.NONSTERISSTEAM]
				}
			],
			width: 130,
			renderCell: ({ colDef, value }) => valueRenderr(colDef, value, 'ModelDataTypes'),
			disabled: disabeldField,
			excludeOnGrid: () => !hasEndoProduct(),
			inputWhen: ({ formik }) => util.nonSterisHide(formik) && hasEndoProduct(),
			readOnly: advModelReadOnlyConditions
		},
		{
			header: 'UserRFID',
			field: 'UserRFID',
			type: 'boolean',
			width: 130,
			inputWhen: hasEndoProduct,
			readOnly: advModelReadOnlyConditions
		},
		{
			header: 'ScopeRFID',
			field: 'ScopeRFID',
			type: 'boolean',
			width: 130,
			inputWhen: hasEndoProduct,
			readOnly: advModelReadOnlyConditions
		},
		{
			header: 'SCMModel',
			field: 'SCMModel',
			type: 'boolean',
			width: 130,
			inputWhen: hasEndoProduct,
			readOnly: advModelReadOnlyConditions
		},
		{
			header: 'MaxHangTime',
			field: 'MaxHangTime',
			type: 'number',
			minValue: 0,
			excludeOnGrid: true,
			inputWhen: ({ formik }) => formik.values.ModelId === RelianceCabinet
		}
	]
});

export default model.createFormBase();
